export default 'https://descours-cabaud-back.obea-ecoute-engagement.fr/1.0/'
